// import React from 'react'
import { Provider as AlertProvider, AlertProviderProps } from 'react-alert'
import { Router } from 'routes'
// import { AlertTemplate } from '@touche-lts/panel-ui/dist'
import { StoreProvider } from 'mobx-stores/store-provider'
import { AlertTemplate } from 'components/shared/alert-template'

const App = () => {
  const alertProps: AlertProviderProps = {
    template: AlertTemplate,
    position: 'bottom left',
    timeout: 5000,
    offset: '30px',
    transition: 'fade'
  }

  return (
    <AlertProvider {...alertProps}>
      <StoreProvider>
        <Router />
      </StoreProvider>
    </AlertProvider>
  )
}


export default App
